import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ConfirmSignup = () => {
  const [message, setMessage] = useState('Confirming your signup...');
  const navigate = useNavigate();

  useEffect(() => {
    const confirmUser = async () => {
      const { error } = await supabase.auth.getSession(); // Check if session is valid

      if (error) {
        setMessage('There was an error confirming your signup.');
      } else {
        setMessage('Signup confirmed! Redirecting to login...');
        setTimeout(() => navigate('/login'), 3000); // Redirect after success
      }
    };

    confirmUser();
  }, [navigate]);

  return (
    <div className="max-w-md mx-auto py-16 text-center">
      <h1 className="text-2xl font-bold mb-4">Account Confirmation</h1>
      <p className="text-gray-600">{message}</p>
    </div>
  );
};

export default ConfirmSignup;
